import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicDomainsApiBreadcrumb } from '../../../modules/AppBreadcrumb';
import { Spinner } from '../../components';
import { AppControllerType, AppRoutes } from '../../interfaces/router';

const CloudflareAccountsListPage = lazy(() => import('../../../pages/DomainsApi/Cloudflare/CloudflareAccountsList.page'));
const CloudflareAccountsCreatePage = lazy(
  () => import('../../../pages/DomainsApi/Cloudflare/CloudflareAccountsCreate.page')
);
const CloudflareAccountsEditPage = lazy(
  () => import('../../../pages/DomainsApi/Cloudflare/CloudflareAccountsEdit.page')
);
const CloudflareAccountsPage = lazy(() => import('../../../pages/DomainsApi/Cloudflare/CloudflareAccounts.page'));

export const DomainsApiCloudflareController: AppControllerType = {
  common: [
    {
      path: AppRoutes.DomainsApiCloudflare + '/*',
      breadcrumb: DynamicDomainsApiBreadcrumb.DynamicCloudflareBreadcrumb
    },
    {
      path: AppRoutes.DomainsApiCloudflareAccounts + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <CloudflareAccountsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsApiBreadcrumb.CloudflareAccountsBreadcrumb.DynamicCloudflareAccountsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.DomainsApiCloudflareAccountsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <CloudflareAccountsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsApiCloudflareAccountsEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <CloudflareAccountsEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.DomainsApiCloudflareAccountsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <CloudflareAccountsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicDomainsApiBreadcrumb.CloudflareAccountsBreadcrumb.DynamicCloudflareAccountsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    }
  ]
};
